import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SUBMISSION_HEADER_ACTIONS } from '../actions/submissions.actions';
import { IRBPlus } from '../types';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs';
import { getIRBPlus } from '../selectors';

@Injectable()
export class SubmissionHeaderFacadeService {
  private readonly _store = inject(Store);

  readonly getIRBState = toSignal(
    this._store.select(getIRBPlus).pipe(map((IRBPlus) => IRBPlus)),
  );

  setIrbPlus(irbState: IRBPlus) {
    this._store.dispatch(SUBMISSION_HEADER_ACTIONS.updateIRBPlus({ irbState }));
  }
}
